module.exports = require('./helpers/bundle-url').getBundleURL('tOZgl') + "logo.c51670a8.svg";